export const BHARAT_MANDAPAM_TEXTS = {
    CONFIRM_TITLE: "Please confirm your Pickup point",
    SELECT_TITLE: "Select your pickup point where order will be delivered.",
    SELECT_SUBTITLE: "Collect your order from pickup point",
    CONFIRM_CTA: "Confirm",
    CHANGE : "Change",
    CHANGE_PICKUP_POINT: "Change Pickup Point",
    CONFIRM_PICKUP_POINT: "Confirm Pickup point",
    NEAREST_BADGE: "NEAREST",
    FOOTER_TEXT: "Not ordering at Bharat Mandapam? Change location from the foodpage",
    PICKUP_POINT_LABEL: "Pickup Point",
    INSIDE_BHARAT_MANDAPAM: "inside Bharat Mandapam",
    COLLECT_YOUR_ORDER_FROM_HERE: "Collect your order from here",
    SELECT_YOUR_PICKUP_POINT: "Choose your pickup point and collect your order from there",
};

export const BHARAT_MANDAPAM_IMAGE = {
    CLOUDINARY_ID: "portal/static-assets/images/delivery_bharat_mandapam.png",
    HEIGHT: 193,
};
